import { useEffect, useState } from "react";
import "../radio-buttons.css";

export function CategoryPlate(props) {
  const currentUrl = window.location.protocol + '//' + window.location.host + window.location.pathname
  const searchParams = new URLSearchParams(document.location.search)
  const [activeClassName, setActiveClassName] = useState(true);
  
  useEffect(() => {
    setActiveClassName(props.choosedOption.categoryPlate.includes("standard") ? true : false)
    for (const [key, value] of Object.entries(props.choosedOption)) {
      if (key !== 'frontPlateImg' && key !== 'rearPlateImg' && key !== 'customBadgeLeft' && key !== 'customBadgeRight') {
        searchParams.set(key, value)
      }
    }
    window.history.replaceState('', '', currentUrl + '?' + searchParams.toString())

  }, [props.choosedOption]);

  return (
    <div className="radio-buttons flex flex-wrap items-center">
      <div onClick={() => props.openModalFormCategory('standard')}
        className={activeClassName 
          ? " radio-buttons__radio radio-buttons__radio--large radio-buttons__radio--active"
          : " radio-buttons__radio radio-buttons__radio--large"}>Road Compliant Plates</div>
      <div onClick={() => props.openModalFormCategory('show')} className={!activeClassName 
            ? " radio-buttons__radio radio-buttons__radio--large radio-buttons__radio--active"
            : " radio-buttons__radio radio-buttons__radio--large"}>Show Plates</div>
    </div>
  );
}
